import { storiesOf } from '@storybook/vue';
import { withKnobs, object, number } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Slider', () => ({
		template: '<dms-slider v-bind="$props" :value.sync="value" />',
		data() {
			return {
				value: 1,
			};
		},
		props: {
			min: {
				default: number('Min', 0),
			},
			max: {
				default: number('Max', 4),
			},
			step: {
				default: number('Step', 1),
			},
			marks: {
				default: object('Marks', {
					0: '0',
					1: '1',
					2: '1/2',
					3: '1/3',
					4: '1/4',
				}),
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
